/* Shared native-pack adapter. Prices come from Shopify bundle variants, never the browser. */
(function (root) {
  'use strict';

  function id(value) { return String(value == null ? '' : value).replace(/^gid:\/\/shopify\/ProductVariant\//, ''); }
  function quantity(value) { const n = Number(value); return Number.isInteger(n) ? n : 0; }
  function resolve(config, product, variantId, selectedQuantity) {
    const q = quantity(selectedQuantity);
    if (!config || config.schema_version !== 'native_pack_config.v1' || config.enabled !== true ||
        String(config.source_product_id) !== String(product?.id) || ![1, 2, 3, 4].includes(q)) return null;
    const source = id(variantId);
    if (!product.variants?.some(v => id(v.id) === source)) return null;
    if (q === 1) return { id: source, quantity: 1, pieces: 1 };
    const pack = config.pack_variants?.[`${source}:${q}`];
    if (!/^\d+$/.test(String(pack || ''))) return null;
    return { id: String(pack), quantity: 1, pieces: q };
  }
  function apply(formData, item) {
    if (!formData || !item) return false;
    formData.set('id', item.id);
    formData.set('quantity', String(item.quantity));
    if (item.pieces > 1) formData.delete('properties[_offer]');
    return true;
  }
  if (typeof module !== 'undefined') module.exports = { resolve, apply };
  if (!root.document) return;

  const config = root.LM_NATIVE_PACK_CONFIG;
  if (!config || config.enabled !== true) return;
  const section = document.querySelector('[data-product-section]');
  const productNode = section?.querySelector('[data-product-json]');
  const form = section?.querySelector('[data-product-form]');
  if (!productNode || !form) return;
  let product;
  try { product = JSON.parse(productNode.textContent); } catch (_) { return; }
  if (String(product.id) !== String(config.source_product_id)) return;
  const baseTierPrice = root.LMQuantityTiers?.price;
  if (baseTierPrice && product.quantity_tiers?.review_price_matrix) {
    root.LMQuantityTiers.price = (tiers, baseUnit, selectedQuantity) => {
      const total = tiers?.review_price_matrix?.[String(baseUnit)]?.[quantity(selectedQuantity) - 1];
      if (Number.isInteger(total) && total > 0) {
        return { totalCents: total, compareCents: baseUnit * Number(selectedQuantity),
          unitCents: Math.round(total / Number(selectedQuantity)), discountPercentage: 0 };
      }
      return baseTierPrice(tiers, baseUnit, selectedQuantity);
    };
  }

  function selectedVariantId() { return form.querySelector('[name="id"]')?.value || product.variants?.[0]?.id; }
  function selectedQuantity() { return section.querySelector('[data-offer-input]:checked')?.value || 1; }
  function refreshCards() {
    const variant = selectedVariantId();
    section.querySelectorAll('[data-lm-offer-tier]').forEach(card => {
      const input = card.querySelector('[data-offer-input]');
      if (!input) return;
      const available = !!resolve(config, product, variant, input.value);
      input.disabled = !available;
      card.classList.toggle('is-disabled', !available);
      if (!available && input.checked) {
        const single = section.querySelector('[data-offer-input][value="1"]');
        if (single) { single.checked = true; single.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    });
  }
  form.addEventListener('formdata', event => {
    const item = resolve(config, product, selectedVariantId(), selectedQuantity());
    if (!apply(event.formData, item)) {
      // Reject a stale or tampered pack selection instead of adding full-price singles.
      event.formData.set('id', '0');
      const error = form.querySelector('[data-form-error]');
      if (error) { error.textContent = 'This pack is unavailable. Please select another quantity.'; error.hidden = false; }
    }
  });
  section.addEventListener('change', () => root.requestAnimationFrame(refreshCards));
  refreshCards();
})(typeof window !== 'undefined' ? window : globalThis);
